import { AssetManager, FOREST_AMBIENT_AUDIO_ID, GHOST_THEME_AUDIO_ID, MAIN_THEME_AUDIO_ID } from '../assets';
import { LevelMapData } from '../entities/model';

export const LEVEL_2_DATA: LevelMapData = {
  id: '02',
  width: 10,
  height: 16,
  realWorld: {
    collisionMap: [[1,1,1,1,1,1,1,1,1,1],[1,1,1,1,1,1,1,1,1,1],[1,1,1,1,1,1,1,1,1,1],[1,1,1,1,1,1,1,1,1,1],[1,0,0,0,0,0,0,0,0,1],[1,0,0,0,0,0,0,0,0,1],[1,0,0,0,0,0,0,0,0,1],[1,0,0,1,1,1,0,0,0,1],[1,0,0,0,0,1,1,1,1,1],[1,0,0,0,0,1,1,1,1,1],[1,0,0,0,0,1,1,1,1,1],[1,0,0,0,0,0,0,0,0,1],[1,0,0,0,0,0,0,0,0,1],[1,0,0,0,0,0,0,0,0,1],[1,1,0,0,1,1,1,1,1,1],[1,1,1,1,1,1,1,1,1,1]],
    backgroundGraphicLayers: [
      {
        tileMapId: AssetManager.graphicalAssets.stage1real.name,
        tileMap: [[16,78,78,78,78,78,78,78,78,16],[45,0,0,0,0,0,0,0,0,47],[45,64,64,64,64,64,64,64,64,47],[45,128,128,128,128,128,128,128,128,47],[45,258,258,458,458,458,460,460,460,47],[45,258,258,458,458,458,460,460,460,47],[45,258,258,458,458,458,460,460,460,47],[45,258,258,111,111,12,423,423,423,47],[45,258,258,258,258,0,0,0,0,0],[45,258,258,258,258,64,64,64,64,64],[45,258,258,258,258,128,128,128,128,128],[18,258,258,258,258,258,258,258,258,258],[4,258,258,258,258,258,258,258,258,258],[68,258,258,258,258,258,258,258,258,258],[132,132,258,258,132,132,132,132,132,132],[150,119,150,119,150,119,150,119,150,119]],
      },
      {
        tileMapId: AssetManager.graphicalAssets.stage1real.name,
        tileMap: [[204,-1,-1,-1,-1,-1,-1,-1,-1,109],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,175,142,142,142,142,142,144,-1],[-1,-1,-1,-1,-1,-1,-1,-1,140,-1],[-1,-1,148,146,146,146,117,-1,140,-1],[-1,-1,140,-1,-1,-1,173,-1,140,-1],[-1,-1,82,142,144,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,148,117],[-1,-1,-1,-1,-1,-1,-1,-1,140,173],[-1,-1,-1,-1,-1,-1,-1,-1,140,173],[-1,-1,-1,-1,-1,-1,-1,-1,140,173],[-1,-1,-1,-1,-1,-1,-1,-1,140,173],[-1,512,-1,-1,514,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]],
      },
      {
        tileMapId: AssetManager.graphicalAssets.stage1real.name,
        tileMap: [[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,138,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,417,146,146,448,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]],
      },
    ],
    foregroundGraphicLayers: [
      {
        tileMapId: AssetManager.graphicalAssets.stage1real.name,
        tileMap: [[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,898,898,898,-1],[-1,-1,-1,-1,-1,-1,962,962,962,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[4,4,4,4,4,4,4,4,4,4],[68,68,993,993,68,68,68,68,68,68],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]],
      },
      {
        tileMapId: AssetManager.graphicalAssets.stage1real.name,
        tileMap: [[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,481,483,483,485,-1,-1,-1,-1,-1],[-1,512,-1,-1,514,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]],
      },
      {
        tileMapId: AssetManager.graphicalAssets.stage1real.name,
        tileMap: [[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,353,-1,-1,384,-1,-1,-1,-1,-1],[898,898,898,898,898,898,898,898,898,898],[962,962,962,962,962,962,962,962,962,962]],
      },
    ],
    lightSettings: {
      playerLightRadius: 6,
      playerLightRolloff: 9,
      fogAlpha: 0.2,
    },
    doors: [
      {
        fromPosition: {x: 6, y: 7},
        toPosition: {x: 6, y: 11},
        toId: '01',
      },
      {
        fromPosition: {x: 7, y: 7},
        toPosition: {x: 7, y: 11},
        toId: '01',
      },
      {
        fromPosition: {x: 8, y: 7},
        toPosition: {x: 8, y: 11},
        toId: '01',
      },
      {
        fromPosition: {x: 2, y: 14},
        toPosition: {x: 13, y: 6},
        toId: '03',
      },
      {
        fromPosition: {x: 3, y: 14},
        toPosition: {x: 14, y: 6},
        toId: '03',
      },
    ],
    themeId: MAIN_THEME_AUDIO_ID,
  },
  ghostWorld: {
    collisionMap: [[1,1,1,1,1,1,1,1,1,1],[1,1,1,1,1,1,1,1,1,1],[1,1,1,1,1,1,1,1,1,1],[1,1,1,1,1,1,1,1,1,1],[1,0,0,0,0,0,0,0,0,1],[1,0,0,0,0,0,0,0,0,1],[1,0,0,0,0,0,0,0,0,1],[1,0,0,1,1,1,0,0,0,1],[1,0,0,0,0,1,1,1,1,1],[1,0,0,0,0,1,1,1,1,1],[1,0,0,0,0,1,1,1,1,1],[1,0,0,0,0,0,0,0,0,1],[1,0,0,0,0,0,0,0,0,1],[1,0,0,0,0,0,0,0,0,1],[1,1,0,0,1,1,1,1,1,1],[1,1,1,1,1,1,1,1,1,1]],
    backgroundGraphicLayers: [
      {
        tileMapId: AssetManager.graphicalAssets.stage1ghost.name,
        tileMap: [[16,78,78,78,78,78,78,78,78,16],[45,0,0,0,0,0,0,0,0,47],[45,64,64,64,64,64,64,64,64,47],[45,128,128,128,128,128,128,128,128,47],[45,258,258,458,458,458,460,460,460,47],[45,258,258,458,458,458,460,460,460,47],[45,258,258,458,458,458,460,460,460,47],[45,258,258,111,111,12,423,423,423,47],[45,258,258,258,258,0,0,0,0,0],[45,258,258,258,258,64,64,64,64,64],[45,258,258,258,258,128,128,128,128,128],[18,258,258,258,258,258,258,258,258,258],[4,258,258,258,258,258,258,258,258,258],[68,258,258,258,258,258,258,258,258,258],[132,132,258,258,132,132,132,132,132,132],[150,119,150,119,150,119,150,119,150,119]],
      },
      {
        tileMapId: AssetManager.graphicalAssets.stage1ghost.name,
        tileMap: [[204,-1,-1,-1,-1,-1,-1,-1,-1,109],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,175,142,142,142,142,142,144,-1],[-1,-1,-1,-1,-1,-1,-1,-1,140,-1],[-1,-1,148,146,146,146,117,-1,140,-1],[-1,-1,140,-1,-1,-1,173,-1,140,-1],[-1,-1,82,142,144,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,148,117],[-1,-1,-1,-1,-1,-1,-1,-1,140,173],[-1,-1,-1,-1,-1,-1,-1,-1,140,173],[-1,-1,-1,-1,-1,-1,-1,-1,140,173],[-1,-1,-1,-1,-1,-1,-1,-1,140,173],[-1,512,146,146,514,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]],
      },
      {
        tileMapId: AssetManager.graphicalAssets.stage1ghost.name,
        tileMap: [[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,138,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,384,353,-1,-1,-1,-1,-1,-1],[-1,-1,448,417,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]],
      },
      {
        tileMapId: AssetManager.graphicalAssets.stage1ghost.name,
        tileMap: [[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]],
      },
    ],
    foregroundGraphicLayers: [
      {
        tileMapId: AssetManager.graphicalAssets.stage1ghost.name,
        tileMap: [[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,898,898,898,-1],[-1,-1,-1,-1,-1,-1,962,962,962,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[4,4,4,4,4,4,4,4,4,4],[68,68,993,993,68,68,68,68,68,68],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]],
      },
      {
        tileMapId: AssetManager.graphicalAssets.stage1ghost.name,
        tileMap: [[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,481,483,483,485,-1,-1,-1,-1,-1],[-1,512,-1,-1,514,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]],
      },
      {
        tileMapId: AssetManager.graphicalAssets.stage1ghost.name,
        tileMap: [[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[898,898,898,898,898,898,898,898,898,898],[962,962,962,962,962,962,962,962,962,962]],
      },
      {
        tileMapId: AssetManager.graphicalAssets.stage1ghost.name,
        tileMap: [[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,972,972,972,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],[-1,-1,594,627,-1,-1,-1,-1,-1,-1],[-1,-1,658,691,-1,-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]],
      },
    ],
    doors: [
      {
        fromPosition: {x: 6, y: 7},
        toPosition: {x: 6, y: 11},
        toId: '01',
      },
      {
        fromPosition: {x: 7, y: 7},
        toPosition: {x: 7, y: 11},
        toId: '01',
      },
      {
        fromPosition: {x: 8, y: 7},
        toPosition: {x: 8, y: 11},
        toId: '01',
      },
      {
        fromPosition: {x: 2, y: 14},
        toPosition: {x: 13, y: 6},
        toId: '03',
      },
      {
        fromPosition: {x: 3, y: 14},
        toPosition: {x: 14, y: 6},
        toId: '03',
      },
    ],
    lightSettings: {
      playerLightRadius: 0,
      playerLightRolloff: 0,
      fogAlpha: 0,
    },
    themeId: GHOST_THEME_AUDIO_ID,
  },
};
